import { colors } from './revenueItems.styles';

export const memberDialogPaperSx = {
  borderRadius: '16px',
  border: `1px solid ${colors.border}`,
  backgroundColor: colors.panel,
  backgroundImage: 'none',
  minWidth: { xs: 'calc(100% - 32px)', md: 560 },
  maxWidth: 560,
};

export const memberDialogTitleWrapSx = {
  px: { xs: 3, md: 5 },
  pt: { xs: 4, md: 5 },
  pb: 1.5,
  textAlign: 'center',
};

export const memberDialogTitleSx = {
  color: '#ffffff',
  fontSize: { xs: '1.5rem', md: '1.75rem' },
  fontWeight: 600,
  lineHeight: 1.2,
  fontFamily: 'Questrial, sans-serif',
  textAlign: 'center',
  width: '100%',
  display: 'block',
};

export const memberDialogContentSx = {
  px: { xs: 3, md: 5 },
  pb: { xs: 3, md: 5 },
  pt: 0,
};

export const memberDialogDescSx = {
  color: colors.textSecondary,
  fontFamily: 'Questrial, sans-serif',
  fontSize: '0.95rem',
  lineHeight: 1.5,
  mb: 3,
  mt: 0.5,
};

export const memberFieldsStackSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2.5,
};

export const memberFieldLabelSx = {
  color: colors.textSecondary,
  fontSize: '0.875rem',
  fontFamily: 'Questrial, sans-serif',
  lineHeight: 1.4,
};

export const memberDialogBtnRowSx = {
  mt: 3,
  display: 'flex',
  justifyContent: 'flex-end',
  flexWrap: 'wrap',
  gap: 1.5,
};

export const memberHeaderActionBtnSx = {
  flexShrink: 0,
  alignSelf: { xs: 'stretch', md: 'center' },
  minHeight: 40,
  px: 2.5,
  borderRadius: '10px',
  textTransform: 'none',
  fontFamily: 'Questrial, sans-serif',
  fontSize: '0.95rem',
  fontWeight: 600,
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#00EDC3',
    opacity: 0.9,
    boxShadow: 'none',
  },
};

/** Text-link style for table row Actions (DAO members / microjob tables). */
export const memberRowActionLinkSx = {
  color: colors.accent,
  fontSize: '0.875rem',
  fontFamily: 'Questrial, sans-serif',
  fontWeight: 400,
  textTransform: 'none',
  minWidth: 0,
  p: 0,
  lineHeight: 1.4,
  background: 'transparent',
  boxShadow: 'none',
  verticalAlign: 'baseline',
  '&:hover': {
    background: 'transparent',
    textDecoration: 'underline',
    color: colors.accent,
  },
  '&.Mui-disabled': {
    color: 'rgba(26, 238, 194, 0.35)',
  },
};

export const memberCancelBtnSx = {
  minWidth: 112,
  height: 44,
  px: 3,
  borderRadius: '16px',
  textTransform: 'none',
  fontSize: '1rem',
  fontFamily: 'Questrial, sans-serif',
  fontWeight: 500,
  backgroundColor: 'transparent',
  color: colors.textPrimary,
  border: '1px solid rgba(255,255,255,0.22)',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.32)',
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    color: 'rgba(243,244,247,0.38)',
    borderColor: 'rgba(255,255,255,0.12)',
  },
};

export const memberConfirmBtnSx = {
  minWidth: 160,
  height: 44,
  px: 3.5,
  borderRadius: '16px',
  textTransform: 'none',
  fontSize: '1rem',
  fontFamily: 'Questrial, sans-serif',
  fontWeight: 600,
  backgroundColor: colors.accent,
  color: '#1a1d23',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: colors.accent,
    opacity: 0.92,
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    backgroundColor: 'rgba(26, 238, 194, 0.22)',
    color: 'rgba(40, 47, 56, 0.55)',
    opacity: 1,
  },
};

export const memberDangerBtnSx = {
  ...memberConfirmBtnSx,
  backgroundColor: '#dc2626',
  color: '#ffffff',
  '&:hover': {
    backgroundColor: '#dc2626',
    opacity: 0.92,
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    backgroundColor: 'rgba(220, 38, 38, 0.35)',
    color: 'rgba(255,255,255,0.7)',
    opacity: 1,
  },
};
